import styles from './HeaderIcon.module.scss';

function HeaderIcon() {
    return (
        <div className={styles['header-icon']}>
            <img src="/PIM.jpg" alt="PIM Logo" width={160} />
        </div>
    );
}

export default HeaderIcon;
